var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { CircularProgress, IconButton } from '@mui/material';
import { keyframes } from '@mui/system';
export var RecordButton = function (_a) {
    var id = _a.id, status = _a.status, label = _a.label, onStart = _a.onStart, onStop = _a.onStop, sx = _a.sx, disabled = _a.disabled, onMouseDown = _a.onMouseDown;
    var isRecording = status === 'recording';
    var isTranscribing = status === 'transcribing';
    return (_jsx(IconButton, { id: id, size: "small", "aria-label": label, "aria-pressed": isRecording, disabled: (disabled && !isRecording) || isTranscribing, onMouseDown: onMouseDown, onClick: isRecording ? onStop : onStart, sx: __spreadArray(__spreadArray([], (Array.isArray(sx) ? sx : [sx]), true), [recordingSx(isRecording)], false), children: isTranscribing ? (_jsx(CircularProgress, { size: 20, sx: inheritColorSx })) : (_jsx(AppIcon, { iconName: isRecording ? 'Square' : 'Microphone01', diameter: "20px", color: isRecording ? 'Colors/Foreground/fg-error-primary' : 'currentColor', fill: isRecording ? 'Colors/Foreground/fg-error-primary' : undefined })) }));
};
var recordingPulse = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n"], ["\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n"])));
var recordingSx = function (isRecording) {
    return function (_a) {
        var backrs = _a.backrs;
        return (__assign({}, (isRecording && {
            backgroundColor: backrs.colors['Colors/Background/bg-error-primary'],
            animation: "".concat(recordingPulse, " 1.5s ease-in-out infinite"),
            '&:hover': {
                backgroundColor: backrs.colors['Colors/Background/bg-error-primary'],
            },
        })));
    };
};
var inheritColorSx = { color: 'inherit' };
var templateObject_1;
